import { render, staticRenderFns } from "./SInfiniteLoader.vue?vue&type=template&id=533a96b2&scoped=true&"
import script from "./SInfiniteLoader.vue?vue&type=script&lang=ts&"
export * from "./SInfiniteLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SInfiniteLoader.vue?vue&type=style&index=0&id=533a96b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a96b2",
  null
  
)

export default component.exports